import React from 'react';
import { useFormContext } from 'react-hook-form';
import './UiInputField.scss';

interface UiInputFieldProps {
    name: string;
    label: string;
    type?: string;
    icon?: React.ComponentType<{ size?: number }>;
}

export default function UiInputField({ name, label, type = 'text', icon: Icon }: UiInputFieldProps) {
    const { register } = useFormContext();

    return (
        <div className="ui-input-field">
            {Icon && <span className="uif-icon"><Icon size={18} /></span>}
            <input type={type} placeholder={label} {...register(name)} />
        </div>
    );
}
